/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type OfferCell_offer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type OfferList_offers$ref: FragmentReference;
declare export opaque type OfferList_offers$fragmentType: OfferList_offers$ref;
export type OfferList_offers = $ReadOnlyArray<{|
  +id: string,
  +$fragmentRefs: OfferCell_offer$ref,
  +$refType: OfferList_offers$ref,
|}>;
export type OfferList_offers$data = OfferList_offers;
export type OfferList_offers$key = $ReadOnlyArray<{
  +$data?: OfferList_offers$data,
  +$fragmentRefs: OfferList_offers$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "OfferList_offers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OfferCell_offer"
    }
  ],
  "type": "Offer"
};
// prettier-ignore
(node/*: any*/).hash = '28bab96f1ba89297181d575297880756';

module.exports = node;
